import { SET_CAMPAIGN_LOADER } from "../actionTypes/campaignActionTypes";

const initialState: any = {
    isLoading: false,
}
const campaignReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CAMPAIGN_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }
        default:
            return state;
    }
}

export default campaignReducer